import React from 'react';

// Create a context with no initial values.
export const ProductSearchContext = React.createContext();

export default ProductSearchContext;
